import React from "react";
import styled from "styled-components";
import { FacebookSquare, Twitter } from "@styled-icons/boxicons-logos";
import { Mail } from "@styled-icons/entypo/Mail";
export const Container = styled.div`
	margin: 0 auto;
    width: 100%;
`;

export const Line = styled.div`
    max-width: 816px;
    background-color: #EFEDEB;
    height: 1px;
    width: 100%;
    margin-bottom: 13px;
`;

export const TopContainer = styled.div`
    width: 817px;
    max-width: 100%;
    margin: auto;
    @media (max-width: 767px){
        width: 100%;
    }
`;

export const CategoriesContainer = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-content: center;
    align-items: center;
    @media (max-width: 767px){
        display: block;
        margin-left: 18px;
    }
`;

export const Category = styled.p`
    color: #747474;
    font-family: Mallory;
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 14px;
    display: inline-block;
    margin-right: 10px;
`;

export const Tags = styled.div`
    box-sizing: border-box;
    text-align: center;
    height: 25px;
    width: 69px;
    border: 1px solid #979797;
    border-radius: 3px;
    display: inline-block;
    color: #747474;
    font-family: Mallory;
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 25px;
    margin-right: 4px;
`;

export const LeftSide = styled.div`
    @media (min-width: 767px){
        flex: 0 1 50%;
    }
`;

export const RightSide = styled.div`
    text-align: right;
    flex: 0 1 50%;
    color: #747474;
    font-family: Mallory;
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 14px;
    vertical-align: top;
    @media (max-width: 767px){
        text-align: left;
        margin-top: 15px;
    }
`;

export const RelatedContainer = styled.div`
    margin-top: 89px;
    padding-top: 50px;
    background: #F7F7F7;
    padding-bottom: 36px;
    @media (max-width: 767px){
        margin-top: 46px;
    }
}
`;

export const RelatedHeading = styled.h4`
    color: #050505;
    font-family: Mallory-Book;
    font-size: 24px;
    font-weight: 300;
    letter-spacing: 0;
    line-height: 22px;
    text-align: center;
    margin: 0 0 34px;
    text-transform: capitalize;
`;

export const AuthorName = styled.h4`
    color: #050505;
    font-family: Canela;
    font-size: 20px;
    font-weight: 300;
    letter-spacing: 0;
    line-height: 22px;
    margin-bottom: 8px;
    @media (max-width: 767px){
        margin: 0;
    }
`;

export const AuthorText = styled.div`
    p{
    color: #212323;
    font-family: Mallory;
    font-size: 12px;
    font-weight: 300;
    letter-spacing: 0;
    line-height: 18px;
    }
`;

export const AuthorImage = styled.img`
    height: 94px;
    width: 94px;
    border-radius: 46px;
    @media (max-width: 767px){
        height: 60px;
        width: 60px;
        margin-right: 22px;
    }
`;

export const AuthorLeft = styled.div`
    flex: 0 1 35%;
`;
export const AuthorRight = styled.div`

`;
export const AuthorFlex = styled.div`
    display: flex;
    align-items: center;
    margin-top: 55px;
    background: #F7F7F7;
    padding: 40px;
    @media (max-width: 767px){
        display: none;
    }
`;

export const AuthorLeftMobile = styled.div`
    display: flex;
    align-items: center;
`;
export const AuthorRightMobile = styled.div`

`;
export const AuthorFlexMobile = styled.div`
    align-items: center;
    margin-top: 26px;
    background: #F7F7F7;
    padding: 16px;
    @media (min-width: 768px){
        display: none;
    }
`;

export const FlexArticles = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    @media (max-width: 1000px){
        display: none;
    }
`;

export const FBicon = styled(FacebookSquare)`
    vertical-align: top;
    @media (max-width: 767px){
        margin: 0 14px;
    }
`;

export const TwitterIcon = styled(Twitter)`
    vertical-align: top;
`;

export const MailIcon = styled(Mail)`
    vertical-align: top;
    @media (max-width: 767px){
        margin: 0 14px;
    }
`;

export const RelatedMaxWidth = styled.div`
    max-width: 1240px;
    margin: auto;
`;